import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// components
import api from '../../../api';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import dayjs from 'dayjs';

// ----------------------------------------------------------------------

export default function MainSettingForm({ data, getAllSettings }) {
  const dispatch = useDispatch();
  // States for input fields

  const [minDeposit, setMinDeposit] = useState(data?.maximumValues?.min_deposit || '');
  const [maxDeposit, setMaxDeposit] = useState(data?.maximumValues?.max_deposit || '');
  const [minWithdrawal, setMinWithdrawal] = useState(data?.maximumValues?.min_withdrawal || '');
  const [maxWithdrawal, setMaxWithdrawal] = useState(data?.maximumValues?.max_withdrawal || '');
  const [minBidAmount, setMinBidAmount] = useState(data?.maximumValues?.min_bid_amount || '');
  const [maxBidAmount, setMaxBidAmount] = useState(data?.maximumValues?.max_bid_amount || '');
  const [welcomeBonus, setWelcomeBonus] = useState(data?.adminDetails?.welcome_bonus || '');
  const [contactNumber, setContactNumber] = useState(data?.adminDetails?.phone || '');
  const [webName, setWebName] = useState(data?.adminDetails?.website_name || '');
  const [webUrl, setWebUrl] = useState(data?.adminDetails?.website_url || '');

  const [openTime, setOpenTIme] = useState();
  const [closeTime, setCloseTime] = useState();

  const handleSave = async () => {
    let reqBody = {
      adminDetails: {
        name: data?.adminDetails?.name,
        email: data?.adminDetails?.email,
        phone: contactNumber,
        website_name: webName,
        website_url: webUrl,
        welcome_bonus: welcomeBonus,
      },
      maximumValues: {
        max_withdrawal: maxWithdrawal,
        min_withdrawal: minWithdrawal,
        max_deposit: maxDeposit,
        min_deposit: minDeposit,
        max_bid_amount: maxBidAmount,
        min_bid_amount: minBidAmount,
        withdrawal_open_time: openTime ? openTime : data?.maximumValues?.withdrawal_open_time,
        withdrawal_close_time: closeTime ? closeTime : data?.maximumValues?.withdrawal_close_time,
      },
    };

    dispatch(loadingStartAction());
    await api.put('/settings', reqBody);
    getAllSettings();
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField
          name="Minimum_Deposit"
          label="Minimum Deposit"
          value={minDeposit}
          onChange={(e) => setMinDeposit(e.target.value)}
        />

        <TextField
          name="Max_Deposit"
          label="Maximum Deposit"
          value={maxDeposit}
          onChange={(e) => setMaxDeposit(e.target.value)}
        />

        <TextField
          name="Minimum_Withdraw"
          label="Minimum Withdraw"
          value={minWithdrawal}
          onChange={(e) => setMinWithdrawal(e.target.value)}
        />

        <TextField
          name="Maximum_Withdraw"
          label="Maximum Withdraw"
          value={maxWithdrawal}
          onChange={(e) => setMaxWithdrawal(e.target.value)}
        />

        <TextField
          name="Minimum_Bid_Amount"
          label="Minimum Bid Amount"
          value={minBidAmount}
          onChange={(e) => setMinBidAmount(e.target.value)}
        />

        <TextField
          name="Maximum_Bid_Amount"
          label="Maximum Bid Amount"
          value={maxBidAmount}
          onChange={(e) => setMaxBidAmount(e.target.value)}
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['TimePicker']}>
            <TimePicker
              defaultValue={dayjs(
                data?.maximumValues?.withdrawal_open_time ? data?.maximumValues?.withdrawal_open_time : new Date()
              )}
              label="Withdraw Open Time"
              value={openTime}
              onChange={(newValue) => setOpenTIme(newValue)}
            />
          </DemoContainer>
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['TimePicker']}>
            <TimePicker 
             defaultValue={dayjs(
              data?.maximumValues?.withdrawal_close_time ? data?.maximumValues?.withdrawal_close_time : new Date()
            )}
            label="Withdraw Close Time" value={closeTime} onChange={(newValue) => setCloseTime(newValue)} />
          </DemoContainer>
        </LocalizationProvider>
        <TextField
          name="Welcome_Bonus"
          label="Welcome Bonus"
          value={welcomeBonus}
          onChange={(e) => setWelcomeBonus(e.target.value)}
        />
        <TextField
          name="Contact_Number"
          label="Contact Number"
          value={contactNumber}
          onChange={(e) => setContactNumber(e.target.value)}
        />
        <TextField
          name="Website_Name"
          label="Website Name"
          value={webName}
          onChange={(e) => setWebName(e.target.value)}
        />
        <TextField name="Website_Url" label="Website Url" value={webUrl} onChange={(e) => setWebUrl(e.target.value)} />
      </Stack>

      <br />
      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleSave}>
        SAVE
      </LoadingButton>
    </>
  );
}
